import { isMaintenanceMode } from "./core/maintenance/isMaintenanceMode";
import { KeycloakThemeEntrypoint, AppEntrypoint } from "./main";
import { lazy, Suspense } from "react";

const MaintenanceEntrypoint = lazy(
  () => import("./core/maintenance/MaintenanceEntrypoint"),
);

export function EntryPoint() {
  const entrypoint = resolveEntrypoint();

  switch (entrypoint) {
    case "KEYCLOAK_THEME":
      return (
        <Suspense>
          <KeycloakThemeEntrypoint />
        </Suspense>
      );
    case "MAINTENANCE":
      return (
        <Suspense>
          <MaintenanceEntrypoint />
        </Suspense>
      );
    case "APP":
      return (
        <Suspense>
          <AppEntrypoint />
        </Suspense>
      );
  }
}

function resolveEntrypoint() {
  if (window.kcContext) {
    return "KEYCLOAK_THEME";
  }
  if (isMaintenanceMode(import.meta.env.VITE_MAINTENANCE_MODE)) {
    return "MAINTENANCE";
  }
  return "APP";
}
